import { IconName } from '@ankorstore/design-system';
import { StatsContactFacet } from './stats.contact.facet';

export enum WidgetTypes {
  RangeWidget = 'range-widget',
  ToggleWidget = 'toggle-widget',
  DropdownWidget = 'dropdown-widget',
  ListWidget = 'list-widget',
  MultiSelectWidget = 'multi-select-widget',
  DateRangeWidget = 'date-range-widget',
}

export interface FilterItem {
  id: string;
  type: 'widget';
  attributes: FilterWidgets;
}

type FilterWidgets = RangeWidget | ToggleWidget | DropdownWidget | ListWidget | DateRangeWidget;
export type FilterWidgetsComponents =
  | RangeWidgetComponent
  | ToggleWidgetComponent
  | DropdownWidgetComponent
  | ListWidgetComponent
  | DateRangeWidgetComponent;

interface DateRangeWidget {
  type: WidgetTypes.DateRangeWidget;
  attributeName: string;
  label: string;
  placeholder: string;
  icon: IconName;
  subLabel: string;
  openByDefault: boolean;
  values: {
    from: string;
    to: string;
    label: string;
  }[];
}

export interface DateRangeWidgetComponent extends DateRangeWidget {}

interface ListWidget {
  type: WidgetTypes.ListWidget;
  attributeName: string;
  label: string;
  icon: IconName;
  multiple: boolean;
  values: {
    value: string | number;
    label: string;
    icon: IconName | 'plus-logo';
  }[];
}

export interface ListWidgetComponent extends ListWidget {}

interface DropdownWidget {
  type: WidgetTypes.DropdownWidget;
  attributeName: string;
  label: string;
  multiple: boolean;
  placeholder: string;
  values: {
    value: string;
    label: string;
  }[];
}

export type DropdownWidgetComponent = Omit<DropdownWidget, 'type'> & {
  type: WidgetTypes.DropdownWidget | WidgetTypes.MultiSelectWidget;
};

interface ToggleWidget {
  type: WidgetTypes.ToggleWidget;
  attributeName: string;
  label: string;
  icon: IconName;
}

export interface ToggleWidgetComponent extends ToggleWidget {
  value: boolean;
}

export interface RangeWidget {
  type: WidgetTypes.RangeWidget;
  attributeName: string;
  label: string;
  separatorLabel: string;
  minLabel: string;
  maxLabel: string;
}

export interface RangeWidgetComponent extends RangeWidget {
  attributes: StatsContactFacet['data'];
}
